import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMaker/response/details/pageContext';

type Result = ModelHookResult<{
	showUnderReviewBanner: boolean;
}>;

export function usePageBanner(): Result {
	const {
		data: {
			decisionMakerResponse: {
				petition: { status },
			},
		},
	} = useDecisionMakerResponsePageData();

	return {
		data: {
			showUnderReviewBanner: status === 'UNDER_REVIEW',
		},
	};
}
